import { useFetch } from '@ad-lucy/hooks';
import { LoggerService } from '@ad-lucy/services/LoggerService';
import { useEffect, useState } from 'react';

import type { ConfigurationPaths } from '../types';
import { useSearchParams } from './useSearchParams';

const logger = LoggerService.getLogger().getModuleLogger(useConfiguration.name);

export function useConfiguration() {
  const { previewConfig: configurationPath } = useSearchParams();

  const [configurationPaths, setConfigurationPaths] = useState<ConfigurationPaths>({});
  const { get, loading } = useFetch<ConfigurationPaths>(!!configurationPath);

  const { contentPath, globalPath, themePath, customCssPath, fontsPath, storesPath } =
    configurationPaths;

  useEffect(() => {
    if (!configurationPath) {
      return;
    }
    get(configurationPath)
      .then(setConfigurationPaths)
      .catch(() => logger.error(`Failed to load '${configurationPath}'`));
  }, [configurationPath, get]);

  return {
    loading,
    contentUrl: contentPath,
    globalUrl: globalPath,
    themeUrl: themePath,
    customCssUrl: customCssPath,
    fontsUrl: fontsPath,
    storesUrl: storesPath,
  };
}
